/**
 * ARENA XL — training-arena realism pass (2026-11-04). Same facility kit as
 * grid_arena (./arenaKit.ts), scaled to the four-quadrant arena: two sector
 * signs per wall, dashed seam-lane lines, scoreboards on both end walls and
 * six floodlight masts. Contract bench: agent/bench-extras-arenas.mjs.
 */
import type * as THREE from "three";
import type { MapExtrasContext } from "../mapExtras.js";
import { arenaLayout, buildKit } from "./arenaKit.js";

export const mapIds = ["arena_xl"];

export function build(ctx: MapExtrasContext): THREE.Object3D | null {
  return buildKit(ctx, arenaLayout(ctx.map, ctx.lowSpec), "extras:arena_xl");
}
